import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./Sidebar.css";
import Logo from "../imgs/logo.png";
import { UilSignOutAlt } from "@iconscout/react-unicons";
import { SidebarData } from "../Data/Data";
import { motion } from "framer-motion";

const Sidebar = ({ setIsAuthenticated, expanded, setExpanded }) => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (window.innerWidth <= 768) {
      setExpanded(false);
    }
  }, [location.pathname, setExpanded]);

  const sidebarVariants = {
    true: { left: "0" },
    false: { left: "-60%" },
  };

  const handleItemClick = (link) => {
    navigate(link);

    // ✅ Force-close sidebar on mobile
    if (window.innerWidth <= 768) setExpanded(false);
  };

  return (
    <motion.div
      className={`sidebar ${expanded ? "expanded" : ""}`}
      variants={sidebarVariants}
      animate={window.innerWidth <= 768 ? `${expanded}` : ""}
    >
      {/* Logo */}
      <div className="logo">
        <img src={Logo} alt="logo" />
        <span>
          Sh<span>o</span>ps
        </span>
      </div>

      {/* Menu */}
      <div className="menu">
        {SidebarData.map((item, index) => {
          const isActive = location.pathname === item.link;

          return (
            <div
              key={index}
              className={`menuItem ${isActive ? "active" : ""}`}
              onClick={() => handleItemClick(item.link)}
            >
              <item.icon />
              <span>{item.heading}</span>
            </div>
          );
        })}

        {/* Logout */}
        <div
          className="menuItem logout"
          onClick={() => {
            localStorage.clear();
            setIsAuthenticated(false);
            navigate("/");
          }}
        >
          <UilSignOutAlt />
          <span>Logout</span>
        </div>
      </div>
    </motion.div>
  );
};

export default Sidebar;
